import { Component, OnInit, Inject } from '@angular/core';

import { ProjectInfo } from '../model/project.model';
import { EmpRoleInfo } from '../model/emprole.model';
import { GlobalService } from '../service/global.service';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';

let today = new Date().toISOString()

@Component({
  selector: 'app-select-projectticket',
  templateUrl: './select-projectticket.component.html',
  styleUrls: ['./select-projectticket.component.css']
})

export class SelectProjectticketComponent implements OnInit {

  ProjectOnPromise: Promise<ProjectInfo[]>
  projectList: ProjectInfo[]
  countprojectlist: number;

  EmpRoleOnPromise: Promise<EmpRoleInfo[]>
  EmpRoleList: EmpRoleInfo[]
  ddlSearchProjectName: string = null
  SearchprojectList: ProjectInfo[]

  public currentPageNumber: number
  public totalPages: number
  RoleCode: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;
  isSearchSubmitted: boolean = false;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;


  _ForK2: string;
  _EmpCode: string;
  _UserName: string;
  currentPath: string = '';

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._UserName = this.activatedRoute.snapshot.params.UserName;
  }


  async ngOnInit() {
    this.LoadSearchProject();
    this.currentPageNumber = 1;

    this.LoadProject();
    this.currentPath = this.router.url;
    // console.log('Current path..... :', this.currentPath);

  }



  ///////////////////////////////////////Functions/////////////////////////////////////////

  LoadProject() {
    this.LoadProjectList()
      .then(
        data => {
          this.projectList = data
          if (data.length == 1) {
            if (!!this._ForK2 && this._ForK2 == 'Y') {
              if (!!this._EmpCode && !!this._UserName) {
                localStorage.setItem("EmpCode", this._EmpCode);
                localStorage.setItem("UserName", this._UserName);
              }
            }

            this.router.navigate(['ticket-management'], { queryParams: { ProjectCode: data[0].ProjectCode, ProjectName: data[0].ProjectName } })

          }
        }
      )

  }

  LoadSearchProject() {
    this.LoadProjectList()
      .then(
        data => {
          this.SearchprojectList = data
        }
      )

  }

  async LoadProjectList(): Promise<ProjectInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let EmpCode = "";
      let UserName = "";
      if (typeof (Storage) !== "undefined") {

        EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode")
        UserName = !!this._UserName ? this._UserName : localStorage.getItem("UserName")

      }

      //Get Emp Role 
      let strjson = "{\"EmpCode\": \"" + EmpCode + "\" " +
        "}";


      await this.httpClient
        .post<EmpRoleInfo[]>(this.baseurl + "Employee/GetEmployeeRoleCriteria",
          strjson, httpOptions).toPromise()
        .then(
          data => {
            this.EmpRoleList = data

            for (let item of this.EmpRoleList) {

              this.RoleCode = item.RoleCode
            }
          }
        )
      //End  Get Emp Role 

      if (this.RoleCode == "MANAGER") { // Check หัวหน้าเห็นหมด

        var objectjson = {};

        objectjson['ProjectCode'] = this.GlobalService.checkUndefinedString(this.ddlSearchProjectName);

        if(this.currentPath && this.currentPath == '/authorize-user'){
            objectjson['EmpCode'] = localStorage.getItem("EmpCode");
        }

        let strjson = JSON.stringify(objectjson);


        this.ProjectOnPromise = this.httpClient
          .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria",
            strjson, httpOptions)
          .toPromise()

      } else if (this.RoleCode == "CUSTOMER") { // Check ลูกค้าเห็นเฉพาะ Complated และ Flag ticket ค้องเป็น Yes

        var objectjson = {};

        objectjson['UserName'] = UserName;
        objectjson['EmpCode'] = EmpCode;
        // objectjson['ProjectCode'] = this.GlobalService.checkUndefinedString(this.ddlSearchProjectName);
        // objectjson['ProjectStatusName'] = 'Completed';
        // objectjson['FlagSupportTicket'] = 'Y';
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;
        objectjson['FlagDelete'] = 'N';

        let strjson = JSON.stringify(objectjson);

        this.ProjectOnPromise = this.httpClient
          .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectbyMemberCriteria",
            strjson, httpOptions)
          .toPromise()
      }
      else {


        var objectjson = {};

        objectjson['UserName'] = UserName;
        objectjson['EmpCode'] = EmpCode;
        objectjson['ProjectCode'] = this.GlobalService.checkUndefinedString(this.ddlSearchProjectName);
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;
        objectjson['FlagDelete'] = 'N';

        let strjson = JSON.stringify(objectjson);



        this.ProjectOnPromise = this.httpClient
          .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectbyMemberCriteria",
            strjson, httpOptions)
          .toPromise()
      }

      return this.ProjectOnPromise;
    }
  }



  displayimgProject(projectcode) {
    return "/Project/Img/" + projectcode;
  }

  displayWarrantyDate(traget) {
    var response = 'Not set';

    // if Support contract type eq Warranty
    if (traget.ProjectSupportContractTypeCode == '1') {
      if (traget.ProjectWarrantyStart != null && traget.ProjectWarrantyStart != '' && traget.ProjectWarrantyEnd != null && traget.ProjectWarrantyEnd != '') {
        response = this.GlobalService.formatDateExcel(traget.ProjectWarrantyStart) + ' to ' + this.GlobalService.formatDateExcel(traget.ProjectWarrantyEnd)
      }

    } // if Support contract type eq Ma 
    else if (traget.ProjectSupportContractTypeCode == '2') {
      if (traget.ProjectMAStart != null && traget.ProjectMAStart != '' && traget.ProjectMAEnd != null && traget.ProjectMAEnd != '') {
        response = this.GlobalService.formatDateExcel(traget.ProjectMAStart) + ' to ' + this.GlobalService.formatDateExcel(traget.ProjectMAEnd)
      }
    }
   

  
    return response
  }

  btnSearchProject() {
    this.isSearchSubmitted = true;
    this.LoadProjectList()
      .then(
        data => {
          this.projectList = data
        }
      )

  }

  btnCancelProject() {
    this.ddlSearchProjectName = null;
    this.isSearchSubmitted = false;
    this.LoadProjectList()
      .then(
        data => {
          this.projectList = data
        }
      )

  }

  onSelectProjectBtn(projectCode: string, projectName: string){
    // console.log("onSelectProjectBtn()...", projectCode, projectName);

    if(this.currentPath && this.currentPath == '/select-projectticket'){
        this.router.navigate(['/ticket-management', { 
          ProjectCode: projectCode, ProjectName: projectName }] );
    }else if(this.currentPath && this.currentPath == '/authorize-user'){
        let empCode = localStorage.getItem("EmpCode");
        if(empCode){
          let path = '/authorize-user-project/'+ empCode;
          this.router.navigate([path
            , { ProjectCode: projectCode, ProjectName: projectName }
          ] );
        }

    }else{

    }


  }



}

